import { FC } from 'react';
import { AuthenticationClientType } from '../../models/clientModel';
import { useCreateEhBuildClientMutation } from '../../services/clients';
import ClientCreatedModal from './components/ClientCreatedModal';
import CreateClientForm from './components/CreateClientForm';

interface Props {
	openModal: boolean;
	setOpenModal: (a: boolean) => void;
}

const CreateEhBuildClient: FC<Props> = ({ openModal, setOpenModal }) => {
	const {
		data,
		mutate: createClient,
		isLoading,
	} = useCreateEhBuildClientMutation();

	const clientData = data?.data as any;
	const handleCreateClient = (values: any) => {
		createClient({
			client: {
				name: values.label,
				description: values.description,
				projectId: values.project,
				environmentId: values.environment,
			},
		});
	};
	return (
		<>
			{data ? (
				<ClientCreatedModal
					{...{
						openModal,
						setOpenModal,
						clientType: AuthenticationClientType.EHBuildClient,
						client: clientData,
					}}
				/>
			) : (
				<CreateClientForm
					{...{
						openModal,
						setOpenModal,
						onSubmit: handleCreateClient,
						isLoading,
						clientType: AuthenticationClientType.EHBuildClient,
					}}
				/>
			)}
		</>
	);
};

export default CreateEhBuildClient;
